import { render, staticRenderFns } from "./PhotoBookInteriorImageManagement.vue?vue&type=template&id=c8c62534&scoped=true"
import script from "./PhotoBookInteriorImageManagement.vue?vue&type=script&lang=js"
export * from "./PhotoBookInteriorImageManagement.vue?vue&type=script&lang=js"
import style0 from "./PhotoBookInteriorImageManagement.vue?vue&type=style&index=0&id=c8c62534&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8c62534",
  null
  
)

export default component.exports